import React from 'react'
import { useTranslation } from 'react-i18next'

import Cta from '../cta'

const ctaAttrs = {
  href: window.thankYouRedirectRoute,
}

const ThankYou = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className='thanks__title title'>
        <h2>{t('Thank You!')}</h2>
      </div>
      <div className='thanks__text text text--center text--gold mb-48'>
        <p>{t('Your request is processed')}</p>
      </div>
      <div className='flex-container align-center'>
        <Cta tag='a' attributes={ctaAttrs} reverse>
          {t('Back to homepage')}
        </Cta>
      </div>
    </>
  )
}

export default ThankYou
